<template>

    <div class="home-wrapper">

        <div class="home-intro">
            <div class="container-fluid">
                <div class="home-intro-inner">
                    <div class="row middle">
                        <div class="col-lg-offset-1 col-lg-11 col-md-offset-0 col-md-12">
                            <p class="home-subtitle">{{ $t('about.intro.subtitle') }}</p>

                            <div class="home-intro-content">
                                <h1 class="home-title" v-html="$t('about.intro.title')"></h1>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <p class="home-intro-bottom">
                {{ $t('about.intro.scrollText') }}

                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="102" viewBox="0 0 8 102"><g id="Group_207" data-name="Group 207" transform="translate(-678.7 -728)"><line id="Line_52" data-name="Line 52" y2="97" transform="translate(683 728)" fill="none" stroke="#fff" stroke-width="1"/><g id="Forward_arrow" data-name="Forward arrow" transform="translate(686.7 818) rotate(90)"><path id="Path_10" data-name="Path 10" d="M-1.692,0l-.671.671L.178,3.213H-10v.959H.178L-2.364,6.713l.671.671L2,3.692Z" transform="translate(10)" fill="#fff"/></g></g></svg>
            </p>
        </div>

        <div class="home-content">
            <div class="container-fluid home-content-intro">

                <div class="row center">
                    <div class="col-lg-8 col-md-12">

                        <p class="home-content-heading">
                            {{ $t('about.content.textHighlight') }}
                        </p>

                    </div>
                </div>

                <div class="home-content-group">
                    <div class="row">

                        <div class="col-lg-offset-1 col-lg-5 col-md-offset-0 col-md-6 col-sm-12">
                            <div class="home-content-image">
                                <div class="home-content-image-group">
                                    <img :src="publicPath+'images/kravica-warehouse.jpg'" alt="">

                                    <p class="home-content-image-caption"></p>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-offset-1 col-lg-4 col-md-offset-0 col-md-6 col-sm-12">
                            <div class="home-content-text" v-html="$t('about.content.text1')">
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="home-content-highlight">
                <div class="container-fluid">
                    <div class="home-content-highlight-inner">

                        <div class="home-content-highlight-text">
                            <div class="home-content-highlight-text-inner">
                                {{ $t('about.content.highlightedText') }}
                            </div>
                        </div>

                        <div class="home-content-highlight-box">
                            {{ $t('about.content.highlightedBoxTextTop') }}
                            <span>8000</span>
                            {{ $t('about.content.highlightedBoxTextBottom') }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="home-content-helper">

                <div class="container-fluid">
                    <div class="home-content-group">
                        <div class="row">

                            <div class="col-lg-offset-1 col-lg-4 col-md-offset-0 col-md-6 col-sm-12">
                                <div class="home-content-text" v-html="$t('about.content.text2') ">
                                </div>
                            </div>

                            <div class="col-lg-offset-1 col-lg-5 col-md-offset-0 col-md-6 col-sm-12">
                                <div class="home-content-image">
                                    <div class="home-content-image-group">
                                        <img :src="publicPath+'images/home-image-2.jpg'" alt="">

                                        <p class="home-content-image-caption"></p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="home-content-group reverse">
                        <div class="row middle">

                            <div class="col-lg-offset-1 col-lg-5 col-md-offset-0 col-md-6 col-sm-12">
                                <div class="home-content-image">
                                    <div class="home-content-image-group">
                                        <img class="space-bottom" :src="publicPath+'images/home-image-3.jpg'" alt="">
                                    </div>

                                    <div class="home-content-image-group">
                                        <img :src="publicPath+'images/home-image-4.jpg'" alt="">

                                        <p class="home-content-image-caption"></p>
                                    </div>

                                </div>
                            </div>

                            <div class="col-lg-offset-1 col-lg-4 col-md-offset-0 col-md-6 col-sm-12">
                                <div class="home-content-text special">
                                    {{ $t('about.content.text3') }}

                                    <!-- <span class="signature">Trial Chamber Judgement to seven high-ranking Bosnian Serb military and police officials - <br>Popović et al.</span> -->
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>

            <div class="home-content-light">
                <div class="container-fluid">
                    <div class="home-content-light-inner align-center">
                        <p class="home-subtitle dark">{{ $t('about.intro.subtitle') }}</p>

                        <div class="home-intro-content">
                            <h1 class="home-title dark" v-html="$t('about.intro.title')"></h1>
                        </div>

                        <router-link :to="{ name: 'story', params: { locale: this.$i18n.locale }}" class="button">
                            <span>{{ $t('about.storyButton') }}</span>
                        </router-link>

                        <!-- <router-link :to="{ name: 'story', params: { locale: this.$i18n.locale }}" class="home-button">{{ $t('about.content.buttonStoryText') }}</router-link> -->
                    </div>
                </div>
            </div>

        </div>

        <div class="home-footer">

            <img :src="publicPath+'images/Logo_MIP_'+this.$i18n.locale+'.png'" alt="Logo MIP EU">

<!--            <img v-else :src="publicPath+'images/Logo_MIP_bhs.png'" alt="Logo MIP EU">-->
        </div>
    </div>

</template>

<script>

export default {
  name: 'Home',
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  methods: {

  }
}
</script>

